import { Text } from '@hg/stylizator/typography'
import parse from 'html-react-parser'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'
import styled from 'styled-components'

const BlogParagraphBlock: React.FC<IWPGBlock> = (props) => (
  <Container>
    <Text type="heading_xsmall" fontWeight={400} useCompact>
      {parse(props.innerHTML)}
    </Text>
  </Container>
)

export default BlogParagraphBlock

const Container = styled.div`
  margin-top: 24px;
`
